import React from "react";

const cardColors = {
  primary: "linear-gradient(135deg, #E3F2FD, #BBDEFB)",
  secondary: "linear-gradient(135deg, #FCE4EC, #F8BBD0)",
  info: "linear-gradient(135deg, #E0F7FA, #B2EBF2)",
  success: "linear-gradient(135deg, #E8F5E9, #C8E6C9)",
};

const titleColors = {
  primary: "#1565C0",
  secondary: "#C2185B",
  info: "#00838F",
  success: "#2E7D32",
};

const iconColors = [
  "#1565C0", "#D81B60", "#00897B", "#F9A825", "#6A1B9A"
];

const RtsSummaryCard = ({ title, value, icons = [], variant = "primary" }) => {
  return (
    <div
      style={{
        position: "relative",
        zIndex: 1,
        borderRadius: "16px",
        padding: "16px",
        flex: 1,
        minWidth: "280px",
        minHeight: "130px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        background: cardColors[variant] || "#f9f9f9",
        border: `2px solid ${titleColors[variant] || "#ccc"}`,
        boxShadow: "0 6px 18px rgba(0, 0, 0, 0.08)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.03)";
        e.currentTarget.style.zIndex = "10";
        e.currentTarget.style.boxShadow = "0 12px 24px rgba(0,0,0,0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.zIndex = "1";
        e.currentTarget.style.boxShadow = "0 6px 18px rgba(0, 0, 0, 0.08)";
      }}
    >
      <div>
        <h4
          style={{
            fontSize: "15px",
            fontWeight: 600,
            color: titleColors[variant] || "#333",
            marginBottom: "6px",
          }}
        >
          {title}
        </h4>
        <div
          style={{
            fontSize: "26px",
            fontWeight: "700",
            color: "#1A1A1A",
            letterSpacing: "0.5px",
          }}
        >
          {value}
        </div>
      </div>

      {icons.length > 0 && (
        <div
          style={{
            marginTop: "14px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          {icons.map((item, i) => {
            const iconColor = iconColors[i % iconColors.length];
            return (
              <button
                key={i}
                onClick={item.onClick}
                title={item.title}
                style={{
                  background: "#fff",
                  padding: "8px",
                  borderRadius: "50%",
                  border: `2px solid ${iconColor}`,
                  color: iconColor,
                  cursor: "pointer",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  transition: "all 0.2s ease-in-out",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.15)";
                  e.currentTarget.style.background = iconColor + "22";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.background = "#fff";
                }}
              >
                {item.icon}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RtsSummaryCard;
